module.exports = __webpack_public_path__ + "img/david-ruggles.1cf62c38.png";